import React, {
  useEffect,
  useMemo,
  useState,
} from "react";

import ReactDOM from "react-dom";

import {
  FiDollarSign,
  FiX,
} from "react-icons/fi";

import API from "../../../../../../utils/apiCalling";

import {
  config,
} from "../../../../../../utils/apiUrl";

import EmployeeSelector
  from "../common/EmployeeSelector";

import {
  formatEmployeeCurrency,
  getEmployeeApiError,
} from "../utils/employee.utils";

import "./EmployeeSalary.css";


const GenerateSalaryModal = ({
  open,

  employees = [],

  defaultMonth,

  defaultYear,

  onClose,

  onSuccess,
}) => {

  const api =
    useMemo(
      () =>
        new API(),
      []
    );


  const [
    form,
    setForm,
  ] =
    useState({
      employeeId: "",
      month: "",
      year: "",
    });


  const [
    loading,
    setLoading,
  ] =
    useState(false);


  const [
    error,
    setError,
  ] =
    useState("");


  useEffect(
    () => {

      if (
        open
      ) {

        setForm({
          employeeId: "",
          month:
            Number(
              defaultMonth
            ) ||
            new Date()
              .getMonth() +
            1,

          year:
            Number(
              defaultYear
            ) ||
            new Date()
              .getFullYear(),
        });


        setError(
          ""
        );

      }

    },
    [
      open,
      defaultMonth,
      defaultYear,
    ]
  );


  if (
    !open
  ) {

    return null;

  }


  const selectedEmployee =
    employees.find(
      (
        employee
      ) =>
        String(
          employee?._id
        ) ===
        String(
          form.employeeId
        )
    );


  const estimatedSalary =
    Number(
      selectedEmployee
        ?.salary
        ?.netSalary ??
      0
    );


  const handleSubmit =
    async (
      event
    ) => {

      event.preventDefault();


      if (
        !form.employeeId
      ) {

        setError(
          "Please select an employee."
        );

        return;

      }


      try {

        setLoading(
          true
        );


        setError(
          ""
        );


        const response =
          await api.post(
            config.generateEmployeeSalary,
            {
              employeeId:
                form.employeeId,

              month:
                Number(
                  form.month
                ),

              year:
                Number(
                  form.year
                ),
            }
          );


        if (
          response?.status !==
          "success"
        ) {

          throw new Error(
            response?.message ||
            "Unable to generate salary."
          );

        }


        await onSuccess?.(
          response?.data
        );

      } catch (
        requestError
      ) {

        setError(
          getEmployeeApiError(
            requestError,
            "Unable to generate salary."
          )
        );

      } finally {

        setLoading(
          false
        );

      }

    };


  return ReactDOM
    .createPortal(

      <div className="employee-salary-modal-root">

        <button
          type="button"
          className="employee-salary-modal-backdrop"
          onClick={
            loading
              ?
              undefined
              :
              onClose
          }
          aria-label="Close"
        />


        <form
          className="employee-salary-modal"
          onSubmit={
            handleSubmit
          }
        >

          <header>

            <div>

              <span>
                <FiDollarSign />
              </span>


              <div>

                <small>
                  PAYROLL
                </small>

                <h3>
                  Generate Salary
                </h3>

              </div>

            </div>


            <button
              type="button"
              onClick={
                onClose
              }
              disabled={
                loading
              }
            >
              <FiX />
            </button>

          </header>


          <div className="employee-salary-modal-body">

            <EmployeeSelector
              employees={
                employees
              }
              value={
                form.employeeId
              }
              onChange={
                (
                  employeeId
                ) =>
                  setForm(
                    (
                      previous
                    ) => ({
                      ...previous,
                      employeeId,
                    })
                  )
              }
              label="Employee"
              required
            />


            <div className="employee-salary-modal-grid">

              <div>

                <label>
                  Salary Month *
                </label>

                <select
                  value={
                    form.month
                  }
                  onChange={
                    (
                      event
                    ) =>
                      setForm(
                        (
                          previous
                        ) => ({
                          ...previous,

                          month:
                            Number(
                              event
                                .target
                                .value
                            ),
                        })
                      )
                  }
                >

                  {
                    [
                      "January",
                      "February",
                      "March",
                      "April",
                      "May",
                      "June",
                      "July",
                      "August",
                      "September",
                      "October",
                      "November",
                      "December",
                    ]
                      .map(
                        (
                          month,
                          index
                        ) => (

                          <option
                            key={
                              month
                            }
                            value={
                              index +
                              1
                            }
                          >
                            {month}
                          </option>

                        )
                      )
                  }

                </select>

              </div>


              <div>

                <label>
                  Salary Year *
                </label>

                <select
                  value={
                    form.year
                  }
                  onChange={
                    (
                      event
                    ) =>
                      setForm(
                        (
                          previous
                        ) => ({
                          ...previous,

                          year:
                            Number(
                              event
                                .target
                                .value
                            ),
                        })
                      )
                  }
                >

                  {
                    Array.from(
                      {
                        length: 7,
                      },
                      (
                        _,
                        index
                      ) =>
                        new Date()
                          .getFullYear() -
                        3 +
                        index
                    )
                      .map(
                        (
                          year
                        ) => (

                          <option
                            key={
                              year
                            }
                            value={
                              year
                            }
                          >
                            {year}
                          </option>

                        )
                      )
                  }

                </select>

              </div>

            </div>


            {
              selectedEmployee
                ?
                (
                  <div className="employee-salary-preview">

                    <div>

                      <span>
                        Basic Salary
                      </span>

                      <strong>
                        {
                          formatEmployeeCurrency(
                            selectedEmployee
                              ?.salary
                              ?.basicSalary
                          )
                        }
                      </strong>

                    </div>


                    <div>

                      <span>
                        Allowances
                      </span>

                      <strong>
                        {
                          formatEmployeeCurrency(
                            selectedEmployee
                              ?.salary
                              ?.allowances
                          )
                        }
                      </strong>

                    </div>


                    <div>

                      <span>
                        Deductions
                      </span>

                      <strong>
                        {
                          formatEmployeeCurrency(
                            selectedEmployee
                              ?.salary
                              ?.deductions
                          )
                        }
                      </strong>

                    </div>


                    <div className="highlight">

                      <span>
                        Current Net Salary
                      </span>

                      <strong>
                        {
                          formatEmployeeCurrency(
                            estimatedSalary
                          )
                        }
                      </strong>

                    </div>

                  </div>
                )
                :
                null
            }


            <div className="employee-salary-note">

              Salary generation should use attendance, leave, advance recovery and the employee's current salary structure on the backend. The frontend only sends the employee and payroll period.

            </div>


            {
              error
                ?
                (
                  <div className="employee-salary-modal-error">
                    {error}
                  </div>
                )
                :
                null
            }

          </div>


          <footer>

            <button
              type="button"
              onClick={
                onClose
              }
              disabled={
                loading
              }
            >
              Cancel
            </button>


            <button
              type="submit"
              disabled={
                loading
              }
            >

              {
                loading
                  ?
                  "Generating..."
                  :
                  "Generate Salary"
              }

            </button>

          </footer>

        </form>

      </div>,

      document.body

    );

};


export default GenerateSalaryModal;